document.addEventListener('DOMContentLoaded', () => {
	const catalog = document.querySelector('.catalog')
	const jacketStyles = catalog.querySelectorAll('.jacket-preset')
	jacketStyles.forEach(container => {
		const openBtn = container.querySelector('.jacket-styles')
		const infoBtn = container.querySelector('.info-button')
		const closeBtn = container.querySelector('.close')
		const events = ['click', 'touchstart']

		events.forEach(event => {
			openBtn.addEventListener(event, e => {
				e.stopPropagation()
				infoBtn.classList.add('open')
				closeBtn.classList.add('open')
				closeBtn.classList.remove('close')
			})
			closeBtn.addEventListener(event, e => {
				e.stopPropagation()
				infoBtn.classList.remove('open')
				closeBtn.classList.remove('open')
				closeBtn.classList.add('close')
			})
			container.addEventListener(event, () => {
				if (infoBtn.classList.contains('open')) {
					infoBtn.classList.remove('open')
					closeBtn.classList.remove('open')
					closeBtn.classList.add('close')
				}
			})
		})
	})

	const filter = catalog.querySelector('.filter')
	const filterBtn = filter.querySelectorAll('.filter-button')

	filterBtn.forEach(btn => {
		btn.addEventListener('click', e => {
			e.stopPropagation()
			filterBtn.forEach(btn => {
				btn.classList.remove('active')
			})
			btn.classList.add('active')
			const filter = btn.dataset.category

			jacketStyles.forEach(style => {
				if (btn.classList.contains('active') && filter !== 'all') {
					if (style.dataset.category.includes(filter)) {
						style.style.display = 'block'
					} else {
						style.style.display = 'none'
					}
				} else {
					style.style.display = 'block'
				}
			})
		})
	})
})
